// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_PaymentRulesResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /payroll/payment_rules endpoint
 *
 * Returns a list of payment rules for franchises in the current filter.
 */
import type { Payroll_PaymentRuleRow } from './Payroll_PaymentRuleRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Payroll_PaymentRulesResponseDados {
items: Payroll_PaymentRuleRow[]
}

export type Payroll_PaymentRulesResponse = ApiResponse<Payroll_PaymentRulesResponseDados>;

registerResponseContract('Payroll_PaymentRulesResponse', {
  items: {
    type: 'array',
    required: true,
    items: {
      id:                { type: 'number',  required: true },
      user_id:           { type: 'string',  required: true },
      franchise_id:      { type: 'number',  required: true },
      rule_type:         { type: 'string',  required: true },
      amount:            { type: 'string',  required: true },
      description:       { type: 'string',  required: false },
      active:            { type: 'number',  required: true },
      created_at:        { type: 'string',  required: true },
      updated_at:        { type: 'string',  required: true },
      meta:              { type: 'string',  required: false },
      frequency:         { type: 'string',  required: false },
      last_payment_date: { type: 'string',  required: false },
      next_due_date:     { type: 'string',  required: false },
    },
  },
})
